import { ReactNode } from "react";
import { colors, colorUtils } from "../../Utils/colors";

import Logo from "../../Assets/images/logo.png"

interface Props {
    children: ReactNode;
}

export const UnAuthorizedLayout = (props: Props) => {
    const { children } = props;

    const backgroundStyle = {
        minHeight: '100vh',
        background: colors.primary.gradient,
        backgroundImage: 'url("https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative' as const,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    const overlayStyle = {
        position: 'absolute' as const,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: colors.background.overlay,
        backdropFilter: 'blur(2px)'
    };

    const cardStyle = {
        background: colors.background.glass,
        backdropFilter: 'blur(10px)',
        borderRadius: '20px',
        boxShadow: `0 20px 40px ${colors.shadow.medium}`,
        border: `1px solid ${colorUtils.withOpacity(colors.neutral.white, 0.2)}`,
        padding: '2rem',
        position: 'relative' as const,
        zIndex: 10,
        transition: 'all 0.3s ease'
    };

    const titleStyle = {
        background: colors.primary.gradient,
        WebkitBackgroundClip: 'text' as const,
        WebkitTextFillColor: 'transparent' as const,
        backgroundClip: 'text' as const
    };

    return (
        <div style={backgroundStyle}>
            <div style={overlayStyle}></div>
            <div className="container-fluid h-100">
                <div className="row h-100 justify-content-center align-items-center">
                    <div className="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3">
                        <div 
                            className="card border-0 shadow-lg" 
                            style={cardStyle}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 25px 50px rgba(0, 0, 0, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
                            }}
                        >
                            <div className="card-body text-center p-4">
                                <div className="mb-4">
                                    <img 
                                        alt="logo" 
                                        src={Logo} 
                                        className="img-fluid" 
                                        style={{ maxWidth: '200px', filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))' }}
                                    />
                                    <h2 className="mt-3 mb-2 fw-bold" style={titleStyle}>Welcome Back</h2>
                                    <p className="text-muted mb-0">Sign in to your photography account</p>
                                </div>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
